import React from 'react';
import { appRoutesUrls } from 'constants/appRoutesUrls';
import { Alert, Col, Container, Row } from 'react-bootstrap';
import { BiCheckCircle } from 'react-icons/bi';
import { Link } from 'react-router-dom';

const Logout = () => {

    return (
        <Container>
            <Row className="justify-content-center d-flex align-items-center mh-100vh">
                <Col md={6} xl={4}>
                    <Alert variant="success" className="text-center p-2 pt-3">
                        <Alert.Heading>
                            <BiCheckCircle size={36} /> <br /> Logout successful
                        </Alert.Heading>
                        <p>
                            You have successfully logged out.<br />
                            Click here to <Link to={appRoutesUrls.login()}><b>Login</b></Link> again.
                        </p>
                    </Alert>
                </Col>
            </Row>
        </Container>
    )
}

export default Logout;